import StandardUploadedHoldingDocuments from "./standard-uploaded-holding-documents";

export default StandardUploadedHoldingDocuments;
